var lists_default = {
  "fontElementMap": "Wv4lS",
  "orderedlist": "_9m-eR",
  "bulletedlist": "SI-6d",
  "listItem": "Y0Xdh"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
